import { ReactComponentManifest } from "web/entrypoints/common/setup";
import AppDownloadBadge from "web/react/components/app-download-badge/app-download-badge";
import AppDownloadBanner from "web/react/components/app-download-banner/app-download-banner";
import AppDownloadTeaserImage from "web/react/components/app-download-teaser-image/app-download-teaser-image";
import BannerContainer from "web/react/components/banner-container/banner-container";
import CustomerCaptureOverlay from "web/react/components/customer-capture-overlay/customer-capture-overlay";
import CookieSettingsContainer from "web/react/components/cookie-settings-container/cookie-settings-container";
import Example from "web/react/components/example/example";
import JSONLDOrganization from "web/react/components/json-ld/json-ld-organization";
import MainNavigation from "web/react/components/main-navigation/main-navigation";
import MainNavigationToggleMobile from "web/react/components/main-navigation/main-navigation-toggle-mobile/main-navigation-toggle-mobile";
import RecentlyViewedEmailCapture from "web/react/components/recently-viewed-email-capture/recently-viewed-email-capture";
import RelatedProductsShowMore from "web/react/components/related-products-show-more/related-products-show-more";
import SearchButtonClassic from "web/react/components/search-button-classic/search-button-classic";
import SearchButton from "web/react/components/search-button/search-button";
import withRedux from "web/react/redux-provider";

/*
    Common components that are on every page (eg header)
*/
const components: ReactComponentManifest = {
    AppDownloadBadge,
    AppDownloadBanner,
    AppDownloadTeaserImage,
    BannerContainer: withRedux(BannerContainer),
    CookieSettingsContainer,
    CustomerCaptureOverlay,
    Example,
    JSONLDOrganization,
    MainNavigation,
    MainNavigationToggleMobile,
    RecentlyViewedEmailCapture,
    RelatedProductsShowMore,
    SearchButtonClassic,
    SearchButton,
};

export default components;
